export default __webpack_public_path__ + "static/media/btc-cover.9743c27f.svg";